import { createFileRoute } from '@tanstack/react-router'
import { StaffMusrenbang } from '../../../../components/StaffMusrenbang'

export const Route = createFileRoute('/platform/desa/$desaId/musrenbang')({
  component: () => {
    const { desaId } = Route.useParams()
    return <StaffMusrenbang desaId={desaId} />
  },
})
